import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgStar = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 21 21"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.667 20.5c-.02-5.516-4.49-9.981-10-9.981 5.523 0 10-4.486 10-10.019.02 5.516 4.49 9.982 10 9.982-5.523 0-10 4.485-10 10.018"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgStar;
